import { computed } from '@vue/composition-api'

export const defaultTitle = ()=>{
    return {
        title: '',
        subTitle: '',
        windowTitle: '',
        buttonName: 'Button'
    }
}

export default function(props, emit){
    const cptTitle = computed(()=>{
        return Object.assign(defaultTitle(), props.titles)
    })

    const submitEvent = ()=>{
        emit('submitEvent', props.GridData.current.data)
    }

    return {
        cptTitle,
        submitEvent
    }
}